module.exports = __webpack_public_path__ + "static/speed-client@2x-b888916ded93d556519059645e59df61.webp";